module.exports = __webpack_public_path__ + "img/GH-kyujin-webdesign001.e0b3beb1.webp";